import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import Whatwedo from  "./WhatWedo";
import WhyChooseUs from "./whychooseUs";
import CoreFeatures from "./CoreFeatures";
const construction = () => {
  return (
    <>
      <Helmet>
        <title>
          AI-Powered Construction Solutions | Smart Project Management & Safety
        </title>

        <meta
          name="description"
          content="Enhance construction operations with LENTERA’s AI-driven solutions. Improve project planning, reduce risks, optimize resource allocation, and ensure safety with intelligent automation."
        />

        <meta
          name="keywords"
          content="AI construction solutions, smart construction management, AI in construction industry, project automation, construction safety AI, predictive analytics construction"
        />
      </Helmet>

      <HeroSection />
      <Whatwedo />
 <WhyChooseUs />
 <CoreFeatures />

   
    </>
  );
};

export default construction;